import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import useFetchUsers from '../../hooks/fetchUsers';
import { Pagination, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

function Merchants() {
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  let searchedMerchant;
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchMerchants, setFetchMerchants] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  const userResp = useFetchUsers();
  const token=getTokenfromUserObj();
  console.log(userResp);
  const userCount = userResp.response ? userResp.response.data.length : 0;
  console.log(userCount);
  useEffect(() => {
    const merchantsList = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.userType === 'A') setEditBtn('block');
      const limit = 1000;
      const offset = 0;
      const merchantResp = await axios.get(`${app.URL}/merchant/view`,{headers:{auth:token}});
      merchantResp.data ? setFetchMerchants(merchantResp.data.data) : ' ';
      merchantResp.data ? setPagesCount(merchantResp.data.data.length) : ' ';
      merchantResp.data ? setRenderList(merchantResp.data.data.slice(0, 50)) : ' ';
    };
    merchantsList();
  }, []);
  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.get(`${app.URL}/merchant/search/${value}`,{headers:{auth:token}});
      console.log(result);
      searchedMerchant = result.data.data;
      setRenderList(searchedMerchant);
      setPagesCount(searchedMerchant.length);
    } catch (e) {
      console.log('Error');
      console.log(e);
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchMerchants.slice(reqObj.offset, reqObj.offset + limit));
    console.log(renderList);
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(fetchMerchants.slice(0, 50));
      setPagesCount(fetchMerchants.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };

  const editUser = (e) => {
    console.log(e);
    localStorage.setItem('merchantId', JSON.stringify(e.merchantId));
    navigate('/merchant/edit', { replace: true });
  };
  const addUser = () => {
    navigate('/merchant/add', { replace: true });
  };
  console.log(renderList);

  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row mt-4'>
        <div className='col-lg-10 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Merchant Management')}</div>
        {/* <div className="col-lg-2 col-md-2 col-sm-2">
        <button class="btn btn-primary button" onClick={addUser}>Add</button>  
        </div>   */}
      </div>
      <div className='row text-center'>
        <div className='col-lg-6 mt-4 offset-lg-1'>
          <Search
            placeholder='Search by Merchant ID/ Organization'
            className='search'
            onChange={handleSearchChange}
            onSearch={onSearch}
            style={{
              width: 300,
            }}
          />
        </div>
        <div className='col-lg-1 col-md-2 col-sm-2 mt-4 '>
          <button class='btn btn-primary button' onClick={addUser}>
            Add
          </button>
        </div>
      </div>

      <div className='col-lg-8 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                {/* <th>{t("ID")}</th> */}
                <th>{t('Merchant ID')}</th>
                <th>{t('Merchant Name')}</th>
                <th>{t('Organization')}</th>
                <th>{t('Status')}</th>
                {/* <th>{t('Status')}</th> */}
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr
                      className='row-hover'
                      onClick={() => {
                        editUser(output);
                      }}
                    >
                      {/* <td >{output.userId}</td> */}
                      {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                      <td style={{ width: '160px' }}>{output.merchantRef ? output.merchantRef : 'null'}</td>
                      <td style={{ width: '160px' }}>{output.merchantName}</td>
                      <td style={{ width: '250px' }}>{output.organizationName}</td>
                      <td style={{ width: '160px' }}>{output.isActive === 1 ? 'Active' : 'Inactive'}</td>
                      <td>
                        <EditTwoTone
                          displayName='edit'
                          twoToneColor='blue'
                          style={{ fontSize: '20px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        />
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
          {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
    </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default Merchants;
